import { render } from "./removeService.vue?vue&type=template&id=280fb53c"
import script from "./removeService.vue?vue&type=script&lang=js"
export * from "./removeService.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__